export default "__VITE_ASSET__815729b9__"